import { Divider, Flex, Image } from "@chakra-ui/react";
import styles from "./ShowCase.module.scss";
import dragonIcon1 from "../../../assets/aimon/dragon-water.png";
import dragonIcon2 from "../../../assets/aimon/dragon-plant.png";
import dragonIcon3 from "../../../assets/aimon/dragon-bird.png";

import leftBg from "../../../assets/aimon/bg-left-yellow.svg";
import rightBg from "../../../assets/aimon/bg-right-blue.svg";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Scrollbar, Navigation } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

export default function ShowCase() {
  const isMobile = window.innerWidth < 768;

  return (
    <Flex className={styles.container} id="showcase">
      <Flex className={styles.bgLeft}>
        <Image src={leftBg} alt="leftBg" />
      </Flex>
      <Flex className={styles.bgRight}>
        <Image src={rightBg} alt="rightBg" />
      </Flex>
      <Flex className={styles.contentGroup}>
        <Divider className={styles.divider} />

        <Flex className={styles.title}>Vimon Showcase</Flex>

        <Flex className={styles.content}>
          <SimpleSlider />
        </Flex>
        <Divider className={styles.divider} mt={"40px"} />
      </Flex>
    </Flex>
  );
}

function SimpleSlider() {
  const isMobile = window.innerWidth < 768;
  const slideModules = isMobile ? [Scrollbar] : [Navigation];
  const scrollBarSetting = isMobile
    ? {
        hide: false,
      }
    : false;
  return (
    <>
      <Swiper
        className="mySwiper"
        navigation={isMobile ? false : true}
        scrollbar={scrollBarSetting}
        modules={slideModules}
        loop
      >
        <SwiperSlide>
          <Flex className={styles.dragonIcon}>
            <img src={dragonIcon1} alt="dragonIcon1" />
          </Flex>
        </SwiperSlide>
        <SwiperSlide>
          <Flex className={styles.dragonIcon}>
            <img src={dragonIcon2} alt="dragonIcon2" />
          </Flex>
        </SwiperSlide>
        <SwiperSlide>
          <Flex className={styles.dragonIcon}>
            <img src={dragonIcon3} alt="dragonIcon3" />
          </Flex>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
